import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ChangePasswordScreen from '../pages/change-password';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="flex items-center justify-center min-h-screen"
        style={{ backgroundColor: 'var(--color-background)' }}
      >
        <div className="flex flex-col items-center gap-4">
          <div
            className="w-10 h-10 rounded-full border-2 border-t-transparent animate-spin"
            style={{ borderColor: 'var(--color-accent)', borderTopColor: 'transparent' }}
          />
          <span className="text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
            Loading…
          </span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login-screen" replace />;
  }

  // Provisioned logins (client access) carry a temporary password until the person picks their
  // own. Render the change screen INSTEAD of the app while the flag is set — done here, in the
  // wrapper every route passes through, so it can't be sidestepped by going to another path.
  // No redirect on purpose: a Navigate here would fight the dashboard's own routing and risk
  // the login loop we already hit once (see CLAUDE.md, trampa 2).
  if (user?.user_metadata?.must_change_password) {
    return <ChangePasswordScreen />;
  }

  return children;
};

export default ProtectedRoute;
